import UserCargoOfficerListRequest, {
  UserCargoOfficerListRequestQueryParams,
} from "./user-cargo-officer-list.request";

const createQueryParams = (
  data: UserCargoOfficerListRequest,
): UserCargoOfficerListRequestQueryParams => {
  return {
    cargoCompany: data.cargoCompany,
    cargoCompanyId: data.cargoCompanyId,
    order: data.order,
    firstName: data.firstName,
    lastName: data.lastName,
    username: data.username,
    email: data.email,
    statusCriteria: data.statusCriteria,
    offset: data.offset,
    limit: data.limit,
    creationEnd: data.creationEnd,
    creationStart: data.creationStart,
  };
};

const userCargoOfficerListRequestFactory = {
  createQueryParams,
};

export default userCargoOfficerListRequestFactory;
